import ContractEquipmentsTableEdit from "./ContractEquipmentsTableEdit";

export default ContractEquipmentsTableEdit;
